<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row ">
                <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 ">
                    <div class="info-box bg-c-yellow card">
                        <div class="info-box-content">
                            <h6><span class="info-box-text">CPU Traffic</span></h6>
                            <h2><span class="info-box-number" ><small>$</small>{{ cpuTrafic.total_amount }}</span></h2>
                            <p class="m-b-0">
                                {{ cpuTrafic.total_comission_plus | toCurrency }}
                                <i class="feather icon-arrow-up m-l-10"></i>
                                {{ cpuTrafic.kpi_plus | toCurrency }} for KPI
                            </p>
                            <i class="card-icon feather icon-filter"></i>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
                <!-- /.col -->
                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <div class="info-box bg-c-blue card">
                        <div class="info-box-content">
                            <h6><span class="info-box-text">Requests Received</span></h6>
                            <h2><span class="info-box-number">{{ requestsReceived.total_number }}</span> </h2>
                            <p class="m-b-0">
                                {{ requestsReceived.approved }} Approved {{ requestsReceived.declined }} Declined
                                <!-- <i class="feather icon-arrow-up m-l-10"></i> -->
                            </p>
                            <i class="card-icon feather icon-users"></i>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
                <!-- /.col -->

                <!-- fix for small devices only -->
                <!-- <div class="clearfix hidden-md-up"></div> -->
                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <div class="info-box bg-c-green card">
                        <div class="info-box-content">
                            <h6><span class="info-box-text">Total KPI</span></h6>
                            <h2><span class="info-box-number">{{ totalKPI.total_reached }}</span> </h2>
                            <p class="m-b-0">
                                From {{ totalKPI.total_reps }} possible
                                <!-- <i class="feather icon-arrow-up m-l-10"></i> -->
                            </p>
                            <i class="card-icon feather icon-radio"></i>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
                <!-- /.col -->
            <!-- /.col -->
            </div>
            <!-- /.row -->

            <div class="row">
                <!-- Left col -->
                <div class="col-md-8">
                                        <!-- /.card -->


                <!-- MAP & BOX PANE -->
                <div class="card col-md-12">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-md-3">
                                <h5 class="card-title">Penging Requests</h5>
                                <span>This table shows requests submited by sales people</span>
                            </div>
                            <div class="col-md-9 p-r-6">
                                <div class="float-right">
                                    <button id="command-reassign" class="btn btn-inverse waves-effect waves-light btn btn-default btn-outline-default waves-effect md-trigger float-right" data-toggle="modal" data-modal  data-target="#addNew">
                                        <i class="icofont icofont-ui-rotation"></i>
                                        Quote Reassign
                                    </button>
                                </div>
                            </div>
                            <!-- <div class="col-md-9 text-right p-r-6">
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                        <i class="fas fa-minus"></i>
                                    </button>
                                    <button type="button" class="btn btn-tool" data-card-widget="remove">
                                        <i class="fas fa-times"></i>
                                    </button>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body p-0">
                        <div class="dt-responsive table-responsive">
                            <table class="table table-striped table-bordered" id="pending_requests_tbl"> 
                                <thead>
                                    <tr>
                                        <th>Sale Rep</th>
                                        <th>Case #</th>
                                        <th>Quote #</th>
                                        <th>Quote Total, $</th>
                                        <th>Request Type</th>                                                                       
                                        <th>Subject</th>       
                                        <th>Status</th>                                                                             
                                        <th>Action</th> 
                                    </tr>
                                </thead>
                                <tbody>
        
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th>Sale Rep</th>
                                        <th>Case #</th>
                                         <th>Quote #</th>
                                        <th>Quote Total, $</th>
                                        <th>Request Type</th>
                                        <th>Subject</th>
                                        <th>Status</th>                                                                        
                                        <th>Action</th>
                                    </tr>
                                </tfoot> 
                            </table>
                        </div>
                    </div>
                <!-- /.card-body -->
                </div>
                <!-- /.card -->
                <div class="card col-md-12">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-md-3">
                                <h5 class="card-title">Sales Rep Remediation Program</h5>
                            </div>
                            <div class="col-md-9 text-right p-r-6">
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                        <i class="fas fa-minus"></i>
                                    </button>
                                    <button type="button" class="btn btn-tool" data-card-widget="remove">
                                        <i class="fas fa-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-0">
                        <div class="table-responsive">
                            <table class="table m-0 table-striped table-bordered nowrap" id="complex-dt">
                                <thead>
                                    <tr>
                                        <th rowspan="2">Name</th>
                                        <th colspan="3">-3 Pay Periods</th>
                                        <th colspan="3">-2 Pay Periods</th>
                                        <th colspan="3">Last Pay Period</th>
                                        <th colspan="3">Current Pay Period</th>
                                    </tr>
                                    <tr>
                                        <th>Total, $</th>
                                        <th># Sold </th>
                                        <th>Earn, $ </th>

                                        <th>Total, $</th>
                                        <th># Sold </th> 
                                        <th>Earn, $ </th>

                                        <th>Total, $</th>
                                        <th># Sold </th> 
                                        <th>Earn, $ </th>   

                                        <th>Total, $</th>
                                        <th># Sold </th> 
                                        <th>Earn, $ </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                </tbody>
                            </table>
                            
                        </div>
                    </div>
                </div>
                <!-- /.card -->
                <div class="card col-md-12">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-md-3">
                                <h5 class="card-title">Completed Requests</h5> <br>
                                <span>This table shows approved / declined requests</span>
                            </div>
                            <div class="col-md-9 text-right p-r-6">
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                        <i class="fas fa-minus"></i>
                                    </button>
                                    <button type="button" class="btn btn-tool" data-card-widget="remove">
                                        <i class="fas fa-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.card -->
                
                </div>
            
                <div class="card col-md-4" v-if="user_kpi">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-3">
                                    <h5 class="card-title">Team KPIs</h5>
                                </div>
                                <div class="col-md-9 text-right p-r-6">
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                        <button type="button" class="btn btn-tool" data-card-widget="remove">
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card-body p-0">
                            <div class="table-responsive">
                                <table class="table table-striped table-bordered" id="team_kpi">
                                    <thead>
                                        <tr>
                                            <th>Sale Rep</th>
                                            <th>KPIs</th>                                                                        
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
            
            <!-- /.col -->
            
            <div class="col-md-12">
                <div class="card">
                    <!-- <template>
                        <DayPilotCalendar id="dp" :config="config" ref="calendar" />
                    </template> -->
                </div>  
            </div>
            </div>
            <!-- /.row -->

            <!-- Modal New -->
            <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Payment Reassign</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <form @submit.prevent="addNew">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Case #</label>
                                        <input v-model="form.case" type="text" name="case" data-form-type="number"
                                            class="form-control" :class="{ 'is-invalid': form.errors.has('case') }">
                                        <has-error :form="form" field="case"></has-error>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Quote #</label>
                                        <input v-model="form.quote" type="text" name="quote" data-form-type="number"
                                            class="form-control" :class="{ 'is-invalid': form.errors.has('quote') }" v-on:change="filterResults">
                                        <has-error :form="form" field="quote"></has-error>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Assigned Sale</label>
                                        <input v-model="form.assigned_sale" type="text" name="assigned_sale"
                                            class="form-control" :class="{ 'is-invalid': form.errors.has('assigned_sale') }" readonly>
                                        <has-error :form="form" field="assigned_sale"></has-error>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Reassign To</label>

                                        <select name="all_sale_reps" v-model="form.all_sale_reps" id="edit_reassign_rep" class="form-control" :class="{ 'is-invalid': form.errors.has('all_sale_reps') }">
                                            <option value="">Select Sales</option>
                                            <option v-for="users in saleUsers" :value="users.user_name">
                                                {{ users.user_name }}
                                            </option>
                                        </select>
                                        <has-error :form="form" field="type"></has-error>
                                    </div>
                                </div>
                            </div>
                            
                                 
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Submit Reassigment</button>
                        </div>
                      </form>
                    </div>
                </div>
            </div>

            <!-- Modal edit-->
            <div class="modal fade" id="editReassign" tabindex="-1" role="dialog" aria-labelledby="editReassign" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                    <div class="modal-header text-center">
                        <h5 class="modal-title " id="exampleModalLongTitle">Quote Information</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <form @submit.prevent="editReassign">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-4 unit">
                                    <label class="f-14">Sales Rep</label>
                                    <div class="input">
                                        <span id="edit_user_name" class='f-22'></span>                                                  
                                    </div>                                                                                              
                                </div>
                                <div class="col-md-3 unit">
                                    <label class="f-14">Case #</label>
                                    <div class="input">
                                        <a href='' id="edit_case_num" class='f-22' target="_blank"></a>                                                 
                                    </div>
                                </div>
                                <div class="col-md-3 unit">
                                    <label class="f-14">Invoice #</label>
                                    <div class="input">
                                        <span id="edit_quote_num" class='f-22'></span>                                                  
                                    </div>                                                                                              
                                </div>
                                <div class="col-md-2 unit">
                                    <label class="f-14">$ Total</label>
                                    <div class="input">
                                        <span id="edit_quote_total" class='f-22'></span>                                                    
                                    </div>                                                                                              
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label  >Type of Charge</label>

                                        <select name="edit_request_type" v-model="form.typeOfCharge" id="edit_request_type" class="form-control" :class="{ 'is-invalid': form.errors.has('edit_request_type') }">
                                            <option v-for="type in typeOfCharge" :value="type">
                                                {{ type }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 divider-text text-center m-t-20 m-b-45">
                                    <span>Quote Commissions</span>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 quote_commissions" >
                                        <table id="quote_commissions">
                                            <thead>
                                                <tr></tr>
                                                <tr></tr>
                                                <tr></tr>    
                                            </thead>
                                            <tbody>
                                                
                                            </tbody>
                                            
                                        </table>

                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 divider-text text-center m-t-20 m-b-45">
                                    <span>Commission Request</span>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Request Subject</label>
                                        <div class="col-md-12 p-0">
                                            <input type="text" id="edit_request_message" class="w-full" name="subject" placeholder="Subject" data-dashlane-rid="3b332e080ef19a79" readonly data-form-type="other" />
                                        </div>
                                        
                                    </div>
                                    <div class="form-group">
                                        <label>Decision Comment</label>
                                        <div class="col-md-12 p-0">                                                                            
                                            <input type="text" id="edit_manager_comment" class="w-full" name="manager_comment" placeholder="Decision Comment" data-form-type="other" />
                                        </div>
                                    </div>
                                </div>
                            </div>                     
                                 
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Submit Reassigment</button>
                        </div>
                      </form>
                    </div>
                </div>
            </div>

            <!-- Modal -->
            <div class="modal fade" id="editQuoteRequest" tabindex="-1" role="dialog" aria-labelledby="editQuoteRequest" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                    <div class="modal-header text-center">
                        <h5 class="modal-title " id="exampleModalLongTitle">Quote Information</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <form @submit.prevent="editReassign">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-5 unit">
                                    <label class="f-14">Sales Rep</label>
                                    <div class="input">
                                        <span id="edit_user_name" class='f-22'></span>                                                  
                                    </div>                                                                                              
                                </div>
                                <div class="col-md-7 unit">
                                    <label>Earned Bonus</label>
                                    <select name="ernedBonus" v-model="form.ernedBonus" id="ernedBonus" class="form-control" :class="{ 'is-invalid': form.errors.has('ernedBonus') }">
                                        <option></option>
                                        <option v-for="(key,bonus) in ernedBonus" :value="bonus">{{ key }}</option>
                                    </select>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-12 divider-text text-center m-t-20 m-b-45">
                                    <span>Commission Request</span>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Request Subject</label>
                                        <div class="col-md-12 p-0">
                                            <input type="text" id="edit_request_message" class="w-full" name="subject" placeholder="Subject" data-dashlane-rid="3b332e080ef19a79" readonly data-form-type="other" />
                                        </div>
                                        
                                    </div>
                                    <div class="form-group">
                                        <label>Decision Comment</label>
                                        <div class="col-md-12 p-0">                                                                            
                                            <input type="text" id="edit_manager_comment" class="w-full" name="manager_comment" placeholder="Decision Comment" data-form-type="other" />
                                        </div>
                                    </div>
                                </div>
                            </div>                     
                                 
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Submit Reassigment</button>
                        </div>
                      </form>
                    </div>
                </div>
            </div>
        </div><!--/. container-fluid -->
    </section>
</template>
    
<script>
    
    import 'datatables.net-bs4';
    import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
    import 'datatables.net-responsive-bs4';
    import 'datatables.net-buttons-bs4';
    import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css';
    import 'datatables.net-buttons-bs4/js/buttons.bootstrap4.min.js';
    import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
    import 'datatables.net-buttons/js/buttons.html5.js';
    
    export default {
        data () {
            return {
                modal: '',
                cpuTrafic: {},
                requestsReceived: {},
                totalKPI: {},
                typeOfCharge : [
                    'Recurring Billing',
                    'Helping Hands',
                    'Double Commission',
                    '25% Split Commission',
                    '50% Split Commission',
                    '75% Split Commission',
                    'Full Commission',
                    'Service Upgrade',
                    'Auth Form Upload',
                ],
                ernedBonus: {
                    "1500" : "Saturday | No Sales | 1500 MXN",
                    "2500" : "Saturday | 3 Sales | 2500 MXN",
                    "5000" : "Saturday | 6 Sales | 5000 MXN",
                    "9000" : "Saturday | 8 Sales | 9000 MXN",
                    "15000": "Saturday | 12 Sales | 15000 MXN",
                    "20000": "Saturday | 16 Sales | 20000 MXN",
                    "2500" : "Sunday | No Sales | 2500 MXN",
                    "3500" : "Sunday | 3 Sales | 3500 MXN",
                    "6000" : "Sunday | 6 Sales | 6000 MXN",
                    "10000" : "Sunday | 8 Sales | 10000 MXN",
                    "15000" : "Sunday | 12 Sales | 15000 MXN",
                    "20000" : "Sunday | 16 Sales | 20000 MXN",
                },
                user_kpi: {},
                sale_remediation: {},
                quotes_requests: [],
                quote_commissions: {},
                saleUsers: {},
                form: new Form({
                    case: '',
                    quote: '',
                    assigned_sale: '',
                    all_sale_reps: '',
                    typeOfCharge: '',
                    ernedBonus: '',
                }),
            }
        },
        mounted() {
            console.log('Dashboard Component mounted.');
            this.getEditData();
            var team_kpi = $('#team_kpi').DataTable({
                responsive: true,
                ajax: {
                    url: 'api/v1/dashboard',
                    "dataSrc" : function ( data ) {
                         // console.log(data.data.quotes_requests);
                         data = data.data.user_kpi;
                         return data;
                    },
                },
                columns: [
                    {
                        data: 'uname',
                        render: function( uname, type, full, meta ) {
                            return uname;
                        }
                    },
                    {   
                        data: 'sum_kpi',
                        render: function( sum_kpi, type, full, meta ) {
                            return sum_kpi;
                        }
                    },
                    {   
                        data: 'label',
                        render: function( label, type, full, meta ) {
                            if(full.sum_kpi >= 5) {
                                return '<label class="label label-md label-success">High Profile Full</label>';
                            }
                            if(full.sum_kpi >= 3 ) {
                                return "<label class='label label-md label-primary'>Sex1 Full</label>";
                            }
                            if(full.sum_kpi >= 1){
                                return "<label class='label label-md label-warning'>Warning</label>";
                            }
                            return "<label class='label label-md label-danger'>Danger</label>";
                            // return status;
                        }
                    },
                ],
                "order": [
                    [1, "desc"]
                ]
            });
            
            var pending_requests_tbl = $('#pending_requests_tbl').DataTable({
                dom: 'Bfrtip',
                responsive: true,
                ajax: {
                    url: 'api/v1/dashboard',
                    "dataSrc" : function ( data ) {
                         // console.log(data.data.quotes_requests);
                         data = data.data.quotes_requests;
                         return data;
                    },
                },
                columns: [
                    {data: 'user_name', searchable: true},
                    {
                        data: 'case_num',
                        searchable: true,
                        render: function( case_num, type, full, meta ) {
                            // console.log(full.cid);
                            // console.log(data);
                            if(case_num == 0)
                            {
                                return case_num;
                            }

                            return "<a href='https://crm.fileretrieval.com/drcsugar/index.php?module=Cases&action=DetailView&record="+ full.cid +"' target='_blank'>"+ case_num +"</a>";

                        }
                    },
                    {data: 'quote_num', searchable: true},
                    {data: 'quote_total', searchable: true},
                    {data: 'request_type', searchable: true},
                    {data: 'request_message', searchable: true},
                    {
                        data: 'request_status', 
                        searchable: true,
                        render: function( request_status, type, full, meta ) {
                            return "<label class='label label-" + full.request_style +"'>" + request_status +"</label>";
                        }
                    },
                    {
                        data: null, 
                        visible: true,
                        render: function(data, type, full, meta) {
                            var deleteButton = "<button class='cm-delete' data-row-id='" + full.id + "'><i class='feather icon-trash-2 f-w-600 f-16 text-c-red'></i></button>";
                            if(full.request_status == "Pending" && full.request_type == "Weekend Bonus") {
                                return "<button class='cm-weekend-edit m-r-15' data-toggle='modal' data-modal data-target='#editQuoteRequest' data-row-id='"+ full.id +"' ><i class='icon feather icon-calendar f-w-600 f-16 text-c-blue'></i></button>" + deleteButton;
                            }
                            
                            return "<button class='cm-edit m-r-15' data-toggle='modal' data-modal  data-target='#editReassign' data-row-id='"+ full.id +"' ><i class='icon feather icon-edit f-w-600 f-16 text-c-green'></i></button>" + deleteButton;
                        }
                    }
                ],
                lengthMenu: [
                     [-1, 50, 25, 10],
                     ['Show all', '50 rows',  '25 rows', '10 rows' ]
                 ],
                "order": [
                    [1, "desc"]
                ],
                buttons: [
                    {extend:'pageLength'},
                    {extend: 'copyHtml5',
                        exportOptions: {
                            columns: [0, ':visible']
                        }
                    },      
                ],
                "pageLength": 10,
                "paging": true,
            });

            var complex_dt = $('#complex-dt').DataTable({
                dom: 'Bfrtip',
                responsive: true,
                ajax: {
                    url: 'api/v1/dashboard',
                    dataSrc: function ( data ) {
                         // console.log(data.data.sale_remediation);
                         data = data.data.sale_remediation;
                         return data;
                    },
                },
                columns: [
                    {
                        data: 'key',
                        // name: 'name',
                        render: function( name, type, full, meta ) {
                            return full.key;
                        }
                    },
                    {
                        data: 'earn_3',
                        render: function( earn_3, type, full, meta ) {
                            return full.earn_3;
                        }
                    },
                    {
                        data: 'cases_3',
                        render: function( cases_3, type, full, meta ) {
                            return full.cases_3;
                        }
                    },
                    {
                        data: 'earn_3',
                        render: function( earn_3, type, full, meta ) {
                            return "<a href='/bint/index.php?page=simulation&user="+ full.key+"&smonth="+ full.month_3 +"&payperiod="+ full.pp_3 + "' target='_blank'>"+ full.earn_3 +"</a>";
                        }
                    },
                    {
                        data: 'earn_2',
                        render: function( total, type, full, meta ) {
                            return full.earn_2;
                        }
                    },
                    {
                        data: 'cases_2',
                        render: function( sold, type, full, meta ) {
                            return full.cases_2;
                        }
                    },
                    {
                        data: 'earn_2',
                        render: function( earn, type, full, meta ) {
                            return "<a href='/bint/index.php?page=simulation&user="+ full.key+"&smonth="+ full.month_2 +"&payperiod="+ full.pp_2 + "' target='_blank'>"+ full.earn_2 +"</a>";
                        }
                    },
                    {
                        data: 'earn_1',
                        render: function( total, type, full, meta ) {
                            return full.earn_1;
                        }
                    },
                    {
                        data: 'cases_1',
                        render: function( sold, type, full, meta ) {
                            return full.cases_1;
                        }
                    },
                    {
                        data: 'earn_1',
                        render: function( earn, type, full, meta ) {
                            return  "<a href='/bint/index.php?page=simulation&user="+ full.key +"&smonth="+ full.month_1 +"&payperiod="+ full.pp_1 + "' target='_blank'>"+ full.earn_1 +"</a>";;
                        }
                    },
                    {
                        data: 'earn_0',
                        render: function( total, type, full, meta ) {
                            return full.earn_0;
                        }
                    },
                    {
                        data: 'cases_0',
                        render: function( sold, type, full, meta ) {
                            return full.cases_0;
                        }
                    },
                    {
                        data: 'earn_0',
                        render: function( earn, type, full, meta ) {
                            return  "<a href='/bint/index.php?page=simulation&user="+ full.key +"&smonth="+ full.month_0 +"&payperiod="+ full.pp_0 + "' target='_blank'>"+ full.earn_0 +"</a>";;
                        }
                    },
                ],
                rowsGroup: [
                    //'first:name',
                ],
                lengthMenu: [
                     [-1, 50, 25, 10],
                     ['Show all', '50 rows',  '25 rows', '10 rows' ]
                 ],
                "order": [
                    [1, "desc"]
                ],
                buttons: [
                    {extend:'pageLength'},
                    {extend: 'copyHtml5',
                        exportOptions: {
                            columns: [0, ':visible']
                        }
                    },      
                ],
                "pageLength": 10,
                "paging": true,
            });
        },
        methods: {
            getEditData() {
                $('#pending_requests_tbl tbody').on('click','.cm-edit', function(e) {
                    var tr = $(this).closest("tr");
                    var data = $("#pending_requests_tbl").DataTable().row(tr).data();
                    console.log('table: ', data);
                    axios.post('api/v1/get_quote_commmissions', data).then(({resp}) => {
                        console.log(resp);
                    });
                    // this.$nextTick(function () {

                    // });
                    // axios.post('api/v1/update_quote_commmissions', data).then(({response}) => {
                    //     console.log(response);
                    // });

                    // console.log(data);
                    // $('#quote_commissions').DataTable({
                    //         ajax: {
                    //             url: 'api/v1/get_quote_commmissions',
                    //             "dataSrc" : function ( data ) {
                    //                  // console.log(data.data.quotes_requests);
                    //                  data = data.data.user_kpi;
                    //                  return data;
                    //             },5
                    //         },
                    // });
                    $('#edit_user_name').text(data.user_name);
                    $('#edit_case_num').text(data.case_num);
                    $('#edit_quote_num').text(data.quote_num);
                    $('#edit_quote_total').text('$'+ data.quote_total);
                    $('#edit_request_message').val(data.request_message);
                });

                $('#pending_requests_tbl tbody').on('click','.cm-weekend-edit', function(e) {
                    var tr = $(this).closest("tr");
                    var data = $("#pending_requests_tbl").DataTable().row(tr).data();
                    
                    $('#editQuoteRequest #edit_user_name').text(data.user_name);
                    $('#editQuoteRequest #edit_request_message').val(data.request_message);
                });

            },
            loadSalesUsers() {
                this.$Progress.start();
               
                this.form.reset();
                
                axios.get("api/v1/userreps").then(({ data }) => {
                    this.saleUsers = data.data
                });
               
                this.$Progress.finish();
            },
            addNew() {
                console.log('add New');

                this.form.post('api/v1/getPaidRep').then((data) => {
                    console.log(data.data);

                }).catch(() => {
                    this.$Progress.fail();
                });
            },
            updateData() {
                console.log('Update data');
                this.form.post('api/v1/getPaidRep').then((data) => {
                    console.log('data updatet');
                });
            },
            filterResults() {
                this.form.post('api/v1/getPaidRep')
                    .then((data) => {
                            this.form.assigned_sale = data.data.data;
                            // success
                            // $('#addNew').modal('hide');
                            Toast.fire({
                              icon: 'success',
                              title: data.data.message
                            });
                        this.$Progress.finish();
                            //  Fire.$emit('AfterCreate');

                        // this.loadUsers();
                    })
                    .catch(() => {
                        this.$Progress.fail();
                    });

                // console.log('olla');
            },
            paidAssignment() {
                console.log('olla');
                // axios.get("api/v1/paidAssignment").then(({ data }) => {
                //     console.log('paidAssignment: ', data.data);
                // }).catch(() => {
                //     this.$Progress.fail();
                // });
            },
            getInfoBox() {
                this.$Progress.start();

                axios.get("api/v1/dashboard").then(({ data }) => {
                    this.cpuTrafic = data.data.cpuTrafic;
                    this.requestsReceived = data.data.requestsReceived;
                    this.totalKPI = data.data.totalKPI;
                    this.user_kpi = data.data.user_kpi;
                    this.sale_remediation = data.data.sale_remediation;
                });

                this.$Progress.finish();
            }
        },
        created() {
            this.$Progress.start();
            this.getEditData();
            this.getInfoBox();
            this.loadSalesUsers(); // load users for modal
            this.$Progress.finish();
        }
    }
</script>
